import React from 'react';
import './footer.scss'
const Footer = () => {
    const twitterHandler = () => {
        window.location.href = "https://twitter.com/charlyhs24"
    }
    const githubHandler = () => {
        window.location.href = "https://github.com/charlyhs24"
    }
    const linkedinHandler = () => {
        window.location.href = "https://www.linkedin.com/in/charly-haholongan-situmorang/"
    }
    return (
        <footer className="footer-container">
            <div className="container">
                <div className="text-center">
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                            <span className="copyright">Copyright &copy; Charly Situmorang 2019</span>
                        </div>
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                            <span className="pr-2">
                            <i className="fab fa-twitter" onClick={twitterHandler}></i>
                            </span>
                            <span className="pr-2">
                            <i className="fab fa-github" onClick={githubHandler}></i>
                            </span>
                            <span>
                            <i className="fab fa-linkedin-in" onClick={linkedinHandler}></i>
                            </span>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4">
                            <span className="termOfUse">Privacy Policy Term Of Use</span>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;